import { Link } from 'react-router-dom';
import { cn } from '@/lib/cn';

interface LogoProps {
  className?: string;
  to?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'full' | 'mark';
}

const sizeMap = {
  sm: { mark: 'h-7 w-7', text: 'text-base' },
  md: { mark: 'h-9 w-9', text: 'text-lg' },
  lg: { mark: 'h-11 w-11', text: 'text-xl' },
} as const;

export function Logo({ className, to = '/', size = 'md', variant = 'full' }: LogoProps) {
  const s = sizeMap[size];
  const content = (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <span
        className={cn(
          'flex items-center justify-center rounded-xl bg-gradient-to-br from-primary to-primary-hover text-primary-ink shadow-sm',
          s.mark,
        )}
        aria-hidden="true"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="h-1/2 w-1/2">
          <path d="M12 2 L12 22" />
          <path d="M5 9 L19 9" />
          <path d="M5 9 C5 13.5 8 17 12 22 C16 17 19 13.5 19 9" />
        </svg>
      </span>
      {variant === 'full' && (
        <span className={cn('font-display font-bold tracking-tight text-ink', s.text)}>
          Locum <span className="text-primary">Network</span>
        </span>
      )}
    </span>
  );
  return to ? <Link to={to}>{content}</Link> : content;
}
